import { FC, useContext, useState, useMemo, useCallback } from "react";
import styles from "./styles.module.scss";
import axios from "axios";
import { Notification } from '@douyinfe/semi-ui';
import { useRouter } from "next/router";
// import MyModal from "../modal";
import { IndexContext } from "@/stores";


export interface IEnFooterProps {

}

export const EnFooter: FC<IEnFooterProps> = ({

}) => {
  const [visible, setVisible] = useState(false)
  const router = useRouter()
  const { time } = useContext(IndexContext);

  return (
    <div className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.left}>
          <img src="/image/footer-logo.png?v=20250422" alt="" />
          <p>CRAFT BEER CHINA 2025 <br />Conference & Exhibition</p>
          <p style={{ fontSize: '14px' }} className={styles.info}>
            <span className={styles.time}>April.15 - April.17 2025</span>
            <span className={styles.site}>Shanghai New International Expo Center</span>
          </p>
        </div>
        <div className={styles.middle}>
          <h3>Quick link</h3>
          <ul>
            <li><a href="/en/about/survey">About CBCE</a></li>
            <li><a href="https://cbce2025.gration.cn/?exhibitor/login&lang=en" target="_blank">Exhibitor Center</a></li>
            <li><a href="https://cbce2025.gration.cn/?member/register&lang=en&code=sites" target="_blank">Visitor Center</a></li>
            <li><a href="/en/summit/2025">Technology Conference</a></li>
            <li><a href="/en/schedule">Activities</a></li>
            <li><a href="/en/media/news">Media Center</a></li>
            <li><a href="/en/contacts">Contact Us</a></li>
          </ul>
        </div>
        <div className={styles.right}>
          <h3>Follow us</h3>
          <ul>
            <li>
              <img src="/image/wx-account-qr.png" alt="" />
              <p>(WeChat Official Account)</p>
            </li>
            <li>
              <img style={{ borderRadius: '50%' }} src="/image/wxqr.jpg?v=2025" alt="" />
              <p>(Mini Program QR)</p>
            </li>
            <li>
              <img src="/image/xiaohongshu-qr.png" alt="" />
              <p>(RED QR)</p>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.copyright}>
        <div>
          <div>
            <a style={{ color: '#fff' }} target="_blank" href="https://www.nuernbergmesse.de/en/company"><p>Copyright © 2022 NürnbergMesse China Co.,Ltd. All rights Reserved</p></a>
            <a style={{ color: '#fff' }} target="_blank" href="http://beian.miit.gov.cn/"><p>沪ICP备09011147号-7</p></a>
          </div>
          <div>
            <div>
              <span>Organizer：</span>
              <img src="/image/messe-logo.png?v=20250422" alt="" />
              <img src="/image/beer.png" alt="" />
            </div>
            <div>
              <span>Support By：</span>
              <a style={{ color: '#fff' }} target="_blank" href="https://www.smartinfo.cn/"><span>SMART-INFO</span></a>
            </div>
          </div>
        </div>

      </div>

      {/* <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal> */}
    </div>
  );
};
